import React, { useEffect } from "react";
import { useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { Link } from "react-router-dom";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";
import Web3 from "web3";
import LotterytokenABI from "../ABI/Lotterytoken.json";
import config from "../config/config";
// import LotteryABI from "../ABI/Lottery.json";
import bonjourapi from "../ABI/bonjourABI";
import bonjourautopoolapi from "../ABI/autopool";
import BigNumber from "bignumber.js";
import { type WalletClient, useWalletClient } from 'wagmi'
import moment from "moment";
import "../App.css";
import isEmpty from "../config/isEmpty";
import { useNavigate } from "react-router-dom";
import { toastAlert } from "../helper/toastAlert";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { toast } from "react-toastify";
import isValidation from "../pages/seperate/validation";
import {
  addLottery,
  addLotterySettings,
  getAddress,
  updateTicketPrice,
  updatePrize,
  getlotterylist,
} from "../action/admin";

import { saveAs } from "file-saver";

import Lottarylist from "../pages/Lottarylist";

import {
  getCurAddr,
  updateregister,
  filter_event,
  getuserrecords,
  claim_list,
  add_Address,
  remove_Address,
  get_nfclist,
  add_Address_new,
  eligible_claim_list
} from "../action/Apicontroller";

import lotteryABI from "../ABI/Lottery.json";
// import {
//   Multicall,
//   ContractCallResults,
//   ContractCallContext,
// } from "ethereum-multicall";
// toast.configure();

let toasterOption = config.toasterOption;

function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

const initialFormValue = {
  operator: "",
  treasury: "",
  injector: "",
};

const initialFormValue1 = {
  lotteryId: "",
  endTime: "",
  ticketPice: "",
  discount: 300,
  rew1: "",
  rew2: "",
  rew3: "",
  rew4: "",
  rew5: "",
  rew6: "",
  fees: 3000,
};

const initialFormValue2 = {
  ticketprize: "",
  AEDprize: "",
};

export default function Settings(props) {
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [provider, setprovider] = React.useState();
  const [address, setaddress] = React.useState();

  // const [UserAccountAddr, Set_UserAccountAddr] = React.useState("");
  // const [UserAccountBal, Set_UserAccountBal] = React.useState(0);
  // const [WalletConnected, Set_WalletConnected] = React.useState("false");
  // const [AddressUserDetails, Set_AddressUserDetails] = useState({});
  // const [Accounts, Set_Accounts] = React.useState("");
  ////

  const [progress, setprogress] = useState("false");
  const [withdrawprogress, setwithdrawprogress] = useState("false");
  const [autowithdrawprogress, setautowithdrawprogress] = useState("false");
  const [earnprogress, setearnprogress] = useState("false");
  const [minprogress, setminprogress] = useState("false");
  const [tokenprogress, settokenprogress] = useState("false");
  const [records, setrecords] = useState([]);
  const [withamt, setwithamt] = useState(0);
  const [autowithamt, setautowithamt] = useState(0);
  const [autowithaddress, setautowithaddress] = useState("");
  const [withaddress, setwithaddress] = useState("");
  const [earnlimit, setearnlimit] = useState(0);
  const [minval, setminval] = useState(0);
  const [tokenprice, settokenprice] = useState(0);
  const [globalpoolamount, setglobalpoolamount] = useState(0);
  const [globalshare, setglobalshare] = useState(0);
  const [usertableheader, setusertableheader] = useState([
    "SNO",
    "USER ID",
    "ADDRESS",
    "Invest_Amount",
    "Re-Invest_Amount",
    "Claimed_Amount",
    "Global_Claimed_Amount",
  ]);
  const [tableheader, settableheader] = useState([
    "SNO",
    "USER ID",
    "ADDRESS",
    "Activity",
    "Amount",
    "DATE",
  ]);
  const [tabledata, settabledata] = useState([]);
  const [usertabledata, setusertabledata] = useState([]);
  const [claimprogress, setclaimprogress] = useState("false");
  const [removeprogress, setremoveprogress] = useState("false");
  const [claimaddress, setclaimaddress] = useState("");
  const [claimlist, setclaimlist] = useState([]);
  const [nfcrecords,setnfcrecords] = useState([]);
  const [eligibleClaims, seeligibleClaims] = useState([]);
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  today = yyyy + "-" + mm + "-" + dd;
  let dateafter = parseInt(dd) + 1;
  let nextday = yyyy + "-" + mm + "-" + dateafter;
  const [currentdate, setcurrentdate] = useState(today);
  const [startdate, setstartdate] = useState("");
  const [enddate, setenddate] = useState("");
  const [currentevent, setcurrentevent] = useState("all");
  const [filterrec, setfilterrec] = useState([]);
  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});
  const [submitButton, setsubmitButton] = useState(false);
  const { operator, injector, treasury } = formValue;
  const [formValue1, setFormValue1] = useState(initialFormValue1);
  // const [formValue2, setFormValue2] = useState(initialFormValue2);
  const [status, setstatus] = useState();

  const [ticketprize, setticketprize] = useState("");

  const [AEDprize, setAEDprize] = useState("");
  const [taxperc, settaxperc] = useState("");
  const [activedata, setActivedata] = useState(false);
  const [removeprogress1, setremoveprogress1] = useState(false);

  

  const {
    lotteryId,
    endTime,
    ticketPice,
    discount,
    rew1,
    rew2,
    rew3,
    rew4,
    rew5,
    rew6,
    fees,
  } = formValue1;
  // const [updatedticketprize, setupdatedticketprize] = useState("");

  // const { ticketprize, AEDprize } = formValue2;

  const history = useNavigate();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  let chainid = config.networkVersion ;
  const { data: walletClient } = useWalletClient({ chainid })


  useEffect(() => {
    getaddress();
    getnfclist();
    getdetails();
    getclaimlist();
    getdowlods();
    getupdatePrize();
    fetchrecord(today, nextday, "all");
    getLotteryList1();
    sample();
    getEligiblelist();
  }, [walletClient]);

  const sample = async () => {
    let web3 = new Web3(window.ethereum);
    const Contract12 = new web3.eth.Contract(
      lotteryABI,
      config.ContractAddress
    );
    console.log(Contract12, "llll");
    var result = await Contract12.methods.adminTaxPercent().call();
    settaxperc(result);
    var result1 = await Contract12.methods.adminTax().call();
    setActivedata(result1);

    console.log(result, "result12345");
  };

  // function
  const onChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } };
    setFormValue(formData);
    console.log(formValue);
  };

  const getLotteryList1 = async () => {
    var test = await getlotterylist();
    const lastItem = test.userValue[test.userValue.length - 1];
    console.log(lastItem?.status, "lastItem......");
    setstatus(lastItem?.status);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setsubmitButton(true);
    let datas = await getCurAddr();
    // console.log(datas.address, localStorage.getItem("account"), "local");
    if (
      datas &&
      datas.address &&
      datas.address != undefined &&
      datas.address != null &&
      datas.address != "" &&
      localStorage.getItem("account")
    ) {
      let web3 = new Web3(
        datas &&
        datas.provider &&
        datas.provider != null &&
        datas.provider != undefined &&
        datas.provider != ""
          ? datas.provider
          : window.ethereum
      );

      // var currAddr = window.web3.eth.defaultAccount;
      var currAddress = await web3.eth.getAccounts();
      if (!currAddress) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }

      console.log(
        config.ContractAddress,
        config.lotterAdmin,
        currAddress[0],
        "jyhgsgf"
      );

      if (currAddress[0] != config.lotterAdmin) {
        toast.error("Please Connect with Owner Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }

      const Contract = new web3.eth.Contract(
        lotteryABI,
        config.ContractAddress
      );
      if (
        !web3.utils.isAddress(operator) ||
        !web3.utils.isAddress(treasury) ||
        !web3.utils.isAddress(injector)
      ) {
        toast.warning("Check Your address Format", toasterOption);
        setsubmitButton(false);
        return false;
      }
      console.log(formValue, "formValue");
      var transactionHash = "";
      var result = await Contract.methods
        .setOperatorAndTreasuryAndInjectorAddresses(
          operator,
          treasury,
          injector
        )
        .send({ from: currAddress[0] })
        .then(async (output) => {
          console.log(output, "output");
          if (output.transactionHash) {
            transactionHash = output.transactionHash;
          } else {
            transactionHash = output;
          }
          console.log(output);
          let reqData = {
            operator,
            treasury,
            injector,
            transactionHash,
          };

          let { error } = await addLotterySettings(reqData);
          console.log(error, "kkkk");
          if (isEmpty(error)) {
            setsubmitButton(false);
            toast.success("Settings updated successfully", toasterOption);
          } else {
            setsubmitButton(false);
            setValidateError(error);
          }
          console.log("error");
        })
        .catch((error) => {
          console.log(error);
          setsubmitButton(false);
          toast.warning("Settings update rejected", toasterOption);
          return false;
        });
      // console.log(result.transactionHash,'transactionhash')

      // if (result.transactionHash) {
      //   transactionHash = result.transactionHash;
      // } else {
      //   transactionHash = result;
      // }
    } else {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      setsubmitButton(false);
      return false;
    }
  };

  async function getaddress() {
    var data = await getAddress();
    console.log(data, "datadatadatadata");
    if (data && data.userValue != undefined) {
      let formdata = {};
      formdata["operator"] = data.userValue.operator;
      formdata["treasury"] = data.userValue.treasury;
      formdata["injector"] = data.userValue.injector;
      setFormValue(formdata);
    }
  }

  async function convert(n) {
    try {
      var sign = +n < 0 ? "-" : "",
        toStr = n.toString();
      if (!/e/i.test(toStr)) {
        return n;
      }
      var [lead, decimal, pow] = n
        .toString()
        .replace(/^-/, "")
        .replace(/^([0-9]+)(e.*)/, "$1.$2")
        .split(/e|\./);
      return +pow < 0
        ? sign +
            "0." +
            "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
            lead +
            decimal
        : sign +
            lead +
            (+pow >= decimal.length
              ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
              : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
    } catch (err) {
      return 0;
    }
  }

  const onchange2 = (e) => {
    if (e.target.name == "time") {
      const { id, value } = e.target;
      console.log(value, "suryaa");
      // var datatime = Date.parse(value);
      const datatime = moment(value).unix();
      console.log(datatime, "suryaa");
      let formData = { ...formValue1, ...{ [id]: datatime } };
      console.log(formData, "suryaa");
      setFormValue1(formData);
    }
  };

  const onChange1 = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    let formData = { ...formValue1, ...{ [id]: value } };
    setFormValue1(formData);
    console.log(formValue1);
  };

  const handleFormSubmit2 = async () => {
    if (ticketprize == "" || undefined || null) {
      toast.warning("Required ticket price", toasterOption);
      return false;
    } else if (isNaN(ticketprize)) {
      toast.warning("Invalid ticket price", toasterOption);
      return false;
    } else if (AEDprize == "" || undefined || null) {
      toast.warning("Required dollar price", toasterOption);
      return false;
    } else if (isNaN(AEDprize)) {
      toast.warning("Invalid dollar price", toasterOption);
      return false;
    } else if (ticketprize <= 0) {
      toast.warning("Ticket price must be greater then 0", toasterOption);
      return false;
    } else if (AEDprize <= 0) {
      toast.warning("Dollar price must be greater then 0", toasterOption);
      return false;
    }
    let reqData = {
      ticketprize,
      AEDprize,
    };

    console.log(reqData, "reqData");
    const result = await updateTicketPrice(reqData);
    if (result) {
      // alert("Succefully updated");
      toast.success("Token Price Updated successfully", toasterOption);
    }
    console.log(result, "result");
  };

  async function getupdatePrize() {
    const result = await updatePrize();
    console.log(result, "result************");
    setticketprize(result.result.result[0]?.ticketprize);
    setAEDprize(result.result.result[0]?.AEDprize);
  }

  const handleFormSubmit1 = async (e) => {
    console.log(status, "status**");
    if (status == 0) {
      toast.warning("Lottery is not closed", toasterOption);
    } else {
      e.preventDefault();
      let reqData = {
        endTime,
        ticketPice,
        rew1,
        rew2,
        rew3,
        rew4,
        rew5,
        rew6,
      };
      console.log(reqData, "formdata");
      let error = isValidation(reqData);
      console.log(error, "errors");
      if (!isEmpty(error)) {
        setValidateError(error);
        // toast.warning("Please Enter Required Fields", toasterOption);
        return false;
      }
      setsubmitButton(true);
      var arra = [];
      arra.push(parseInt(rew1 * 100));
      arra.push(parseInt(rew2 * 100));
      arra.push(parseInt(rew3 * 100));
      arra.push(parseInt(rew4 * 100));
      arra.push(parseInt(rew5 * 100));
      arra.push(parseInt(rew6 * 100));

      let datas = await getCurAddr();

      if (
        !(
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        )
      ) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }
      let web3 = new Web3(
        datas &&
        datas.provider &&
        datas.provider != null &&
        datas.provider != undefined &&
        datas.provider != ""
          ? datas.provider
          : window.ethereum
      );

      var currAddr = await web3.eth.getAccounts();
      console.log(currAddr, "web3");
      if (!currAddr) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }
      if (
        parseInt(rew1 * 100) +
          parseInt(rew2 * 100) +
          parseInt(rew3 * 100) +
          parseInt(rew4 * 100) +
          parseInt(rew5 * 100) +
          parseInt(rew6 * 100) >
          10000 ||
        parseInt(rew1 * 100) +
          parseInt(rew2 * 100) +
          parseInt(rew3 * 100) +
          parseInt(rew4 * 100) +
          parseInt(rew5 * 100) +
          parseInt(rew6 * 100) <
          10000
      ) {
        toast.warning("Total split up must be 100", toasterOption);
        setsubmitButton(false);
        return false;
      }

      var currentDate = new Date();

      // var timeMIn = new Date(currentDate.setMinutes(currentDate.getHours() + 4));
      var timeMIn = new Date();

      // var timeMIn = new Date(
      //   currentDate.setHours((currentDate.getHours()) + 4)
      // );

      var timeMax = new Date(currentDate.setDate(currentDate.getDate() + 4));

      var endDate = new Date(endTime * 1000);

      console.log(endDate, "endDate");
      console.log(endDate, timeMIn, timeMax, "saranTestingLOggggk");

      var timeMIn = currentDate.getMinutes();
      var endMinute = moment(endDate).format("mm");

      console.log(endMinute, "endMinute");
      var minutes = endMinute - timeMIn;
      var n = Math.abs(minutes);
      console.log(n, "minutes");
      if (n < 10) {
        toast.warning("It must be greater than 10 Minutes", toasterOption);
        setsubmitButton(false);
        return false;
      } else if (endDate > timeMax) {
        toast.warning("It must be lesser than 4 days", toasterOption);
        setsubmitButton(false);
        return false;
      }

      const Contract = new web3.eth.Contract(
        lotteryABI,
        config.ContractAddress
      );
      let convertamout = ticketPice * 1000000000000000000;
      var amountFIn = await convert(convertamout);

      console.log(endTime, amountFIn.toString(), 2000, arra, 3000, "llll");
      const timeanddate = endTime / 1000;
      var result = await Contract.methods
        .startLottery(endTime, amountFIn.toString(), 2000, arra, 3000)
        .send({ from: currAddr[0] })
        .then(async (result) => {
          var ticketId = result.events.LotteryOpen.returnValues.lotteryId;

          var transactionHash = "";

          if (result.transactionHash) {
            transactionHash = result.transactionHash;
          } else {
            transactionHash = result;
          }

          let reqData = {
            ticketId,
            endTime,
            ticketPice,
            discount,
            rew1,
            rew2,
            rew3,
            rew4,
            rew5,
            rew6,
            fees,
            transactionHash,
            endDate,
          };

          let { error } = await addLottery(reqData);

          setsubmitButton(false);
          toast.success("Lottery updated successfully", toasterOption);

          setTimeout(() => {
            window.location.reload();
          }, 4000);
          // history.push("/LotteryList");
        })
        .catch((error) => {
          setsubmitButton(false);
          setValidateError(error);
          toast.warn("Ooops! Rejected", toasterOption);
        });
    }
  };

  async function empty() {}

  function getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  async function getclaimlist() {
    let _records = await claim_list();
    if (_records && _records.data && _records.data.data) {
      setclaimlist(_records.data.data);
    } else {
      setclaimlist([]);
    }
  }

  async function getEligiblelist() {
    let _records = await eligible_claim_list();
    if (_records && _records.data && _records.data.data) {
      seeligibleClaims(_records.data.data);
    } else {
      seeligibleClaims([]);
    }
  }

  async function getnfclist(){
    let rec = await get_nfclist();
    if (rec && rec.data && rec.data.data) {
      setnfcrecords(rec.data.data);
    }else{
      setnfcrecords([]);
    }
  }

  async function getdowlods() {
    let rec = await getuserrecords();
    let record = [];
    for (let i in rec?.data?.data) {
      var obj_rec = {
        SNO: parseInt(i) + 1,
        UserId: rec.data.data[i].userid,
        Address: rec.data.data[i]._id.address,
        Investamt: rec.data.data[i].joined,
        reInvestamt: rec.data.data[i].reinvest,
        //reTopup : (parseFloat(rec.data.data[i].retopup1)+parseFloat(rec.data.data[i].retopup2)/1e18).toFixed(2),
        claim: (
          parseFloat(rec.data.data[i].claim1) +
          parseFloat(rec.data.data[i].claim2) / 1e18
        ).toFixed(2),
        globalclaim: rec.data.data[i].globalclaim,
        //Date : moment(rec.data.data[i].createdAt).format('MMM Do YYYY, h:mm:ss A')
      };
      record.push(obj_rec);
      if (parseInt(i) + 1 == rec.data.data.length) {
        setusertabledata(record);
      }
    }
  }

  // async function saveAsExcel() {
  //   XlsxPopulate.fromBlankAsync().then(async (workbook) => {
  //     const sheet1 = workbook.sheet(0);
  //     const sheetData = getSheetData(tabledata, tableheader);
  //     const totalColumns = sheetData[0].length;
  //     sheet1.cell("A1").value(sheetData);
  //     const range = sheet1.usedRange();
  //     const endColumn = String.fromCharCode(64 + totalColumns);
  //     sheet1.row(1).style("bold", true);
  //     sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
  //     range.style("border", true);
  //     return workbook.outputAsync().then((res) => {
  //       saveAs(res, "file.xlsx");
  //     });
  //   });
  // }

  // async function saveuserAsExcel() {
  //   XlsxPopulate.fromBlankAsync().then(async (workbook) => {
  //     const sheet1 = workbook.sheet(0);
  //     const sheetData = getSheetData(usertabledata, usertableheader);
  //     const totalColumns = sheetData[0].length;
  //     sheet1.cell("A1").value(sheetData);
  //     const range = sheet1.usedRange();
  //     const endColumn = String.fromCharCode(64 + totalColumns);
  //     sheet1.row(1).style("bold", true);
  //     sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
  //     range.style("border", true);
  //     return workbook.outputAsync().then((res) => {
  //       saveAs(res, "file.xlsx");
  //     });
  //   });
  // }

  const withamtchange = (e) => {
    setwithamt(e.target.value);
  };

  const withaddrchange = (e) => {
    setwithaddress(e.target.value);
  };

  const autowithamtchange = (e) => {
    setautowithamt(e.target.value);
  };

  const autowithaddrchange = (e) => {
    setautowithaddress(e.target.value);
  };

  const earnlimitchange = (e) => {
    setearnlimit(e.target.value);
  };

  const minvalchange = (e) => {
    setminval(e.target.value);
  };

  const tokenvalchange = (e) => {
    settokenprice(e.target.value);
  };

  const claimaddresschange = (e) => {
    setclaimaddress(e.target.value);
  };

  const globalsharechange = (e) => {
    setglobalshare(e.target.value);
  };

  const startdatechange = async (e) => {
    setstartdate(e.target.value);
    fetchrecord(e.target.value, enddate, currentevent);
  };

  const enddatechange = async (e) => {
    setenddate(e.target.value);
    fetchrecord(startdate, e.target.value, currentevent);
  };

  const selectchange = async (e) => {
    setcurrentevent(e.target.value);
    fetchrecord(startdate, enddate, e.target.value);
  };

  async function getdetails() {
    let datas = await getCurAddr();
    if (
      datas &&
      datas.address &&
      datas.address != null &&
      datas.address != undefined &&
      datas.address != ""
    ) {
      let web3call = new Web3(
        datas &&
        datas.provider &&
        datas.provider != null &&
        datas.provider != undefined &&
        datas.provider != ""
          ? datas.provider
          : window.ethereum
      );
      try {
        const multicall = new Multicall({
          web3Instance: web3call,
        });
                        console.log("===========vvv")

        var contractCallContext = [
          {
            reference: "details",
            contractAddress: config.bonjourcontract,
            abi: bonjourapi,
            calls: [
              {
                reference: "earnLimit",
                methodName: "earnLimit",
                methodParameters: [],
              },
              {
                reference: "getAllglobalPoolAddress",
                methodName: "getAllglobalPoolAddress",
                methodParameters: [],
              },
              {
                reference: "minWithdrawAmount",
                methodName: "minWithdrawAmount",
                methodParameters: [],
              },
              {
                reference: "globalPoolShare",
                methodName: "globalPoolShare",
                methodParameters: [],
              },
               {
                reference: "bonjourtokenPrice",
                methodName: "bonjourtokenPrice",
                methodParameters: [],
              },
            ],
          },
        ];

        const results = await multicall.call(contractCallContext);
        var minWithdrawAmount = await getFormatMulticall(
          results,
          "minWithdrawAmount",
          0
        );
        var getAllglobalPoolAddress = await getFormatMulticall(
          results,
          "getAllglobalPoolAddress",
          0
        );
        var globalPoolShare = await getFormatMulticall(
          results,
          "globalPoolShare",
          0
        );
        var token_price = await getFormatMulticall(
          results,
          "bonjourtokenPrice",
          0
        );
        let global_amt = await bignumber(globalPoolShare[0]);
        let bonjour_token_price = await bignumber(token_price[0]);
        settokenprice(bonjour_token_price);
        setglobalpoolamount(global_amt);
        setrecords(getAllglobalPoolAddress);
        var earnLimit = await getFormatMulticall(results, "earnLimit", 0);
        earnLimit = await bignumber(earnLimit[0]);
        setearnlimit(earnLimit);
        var minamt = await getFormatMulticall(results, "minWithdrawAmount", 0);
        minamt = await bignumber(minamt[0]);
        minamt = parseFloat(minamt) / 1e18;
        setminval(minamt);
      } catch (Err) {
        console.log(Err, "======errvvvv");
      }
    }
  }

  function getFormatMulticall(results, name, pos) {
    console.log(results, name,'results, name')
    try {
      var index =
        results &&
        results.results &&
        results.results.details &&
        results.results.details.callsReturnContext &&
        results.results.details.callsReturnContext.findIndex(
          (val) => val.reference == name
        );
      var returnVal =
        results.results.details.callsReturnContext[index] &&
        results.results.details.callsReturnContext[index].returnValues
          ? results.results.details.callsReturnContext[index].returnValues
          : "";
      return returnVal;
    } catch (err) {
      console.log(err, "==+++++++");
      return "";
    }
  }

 function getFormatMulticall1(results, name, pos) {

    try {
        var returnVal = (results && results.results && results.results[name]
            && results.results[name].callsReturnContext &&
            results.results[name].callsReturnContext &&
            results.results[name].callsReturnContext[pos] &&
            results.results[name].callsReturnContext[pos].returnValues &&
            results.results[name].callsReturnContext[pos].returnValues[0]) ?
            results.results[name].callsReturnContext[pos].returnValues[0] : "";
        return returnVal;
    } catch (err) {
        return "";
    }
}

  async function bignumber(inputs) {
    let ten = new BigNumber(inputs.hex, 16);
    var value = ten.toString(10);
    return value;
  }

  async function addaddressNew() {
    try {
      setclaimprogress("true");
      let datas = await getCurAddr();
      if (
        datas &&
        datas.address &&
        localStorage.getItem("account")
      ) {
        let web3 = new Web3(
          datas &&
          datas.provider 
            ? datas.provider
            : window.ethereum
        );
        var bonjourContract = new web3.eth.Contract(
          bonjourapi,
          config.bonjourcontract
        );
        let owneraddress = await bonjourContract.methods.owner().call();
        if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
          if (
            claimaddress && claimaddress !=""
          ) {

            var allAddr = claimaddress.split(",");
            console.log(allAddr,'allAddrallAddr',allAddr.length)
            if(allAddr && allAddr.length==0){
              toastAlert(
                "error",
                "Invalid address",
                "network"
              );
              return;
            }
            var isValid="true";
            var contractCallContext =[];
            const multicall = new Multicall({
              web3Instance: web3,
          });
          var removeDuplicates = allAddr.filter((item,
            index) => allAddr.indexOf(item) === index);
            allAddr = removeDuplicates;
           
            var addrList = [];
            for(var a=0;a<allAddr.length;a++){

              if (!web3.utils.isAddress(allAddr[a])) {
                isValid = "false";
                break;
              }
              addrList.push({
                address:allAddr[a]
              })
              contractCallContext.push({
                reference: "checkExits-"+a,
                contractAddress: config.bonjourcontract,
                abi: bonjourapi,
                calls: [
                    {
                        reference: "userprofile-"+a,
                        methodName: "users",
                        methodParameters: [allAddr[a]],
                    }
                ],
            })

            }

            if(isValid=="false"){
              toastAlert(
                "error",
                "Invalid address",
                "network"
              );
              return;
            }

            const results = await multicall.call(contractCallContext);
            for(var c=0;c<allAddr.length;c++){
              var userprofile = await getFormatMulticall1(results, "checkExits-"+c, 0);
              if(!userprofile){
                toastAlert(
                  "error",
                  "User wallet not joined under our Bonjour",
                  "network"
                );
                return;
              }
            }

              
            await bonjourContract.methods.addAllowClaim(allAddr).send({
              from: datas.address,
            });
            let rect = {
              address: JSON.stringify(addrList),
            };
            let _records = await add_Address_new(rect);
            if (_records && _records.data && _records.data.message) {
              setclaimprogress("false");
              toastAlert("success", _records.data.message, "network");
              setclaimaddress("");
              getEligiblelist();
            }
            
          } else {
            setclaimprogress("false");
            toastAlert("error", "Enter Valid Address", "network");
          }
        } else {
          setclaimprogress("false");
          toastAlert("error", "Login into Admin Address", "network");
        }
      } else {
        setclaimprogress("false");
        toastAlert("error", "Please select BSC chain network", "network");
      }
    } catch (err) {
      console.log(err, "--");
      toastAlert("error", "Process Cancelled", "network");
      setclaimprogress("false");
    }
  }

  async function addaddress() {
    try {
      setclaimprogress("true");
      let arr = [];
      let datas = await getCurAddr();
      if (
        datas &&
        datas.address &&
        datas.address != undefined &&
        datas.address != null &&
        datas.address != "" &&
        localStorage.getItem("account")
      ) {
        let web3 = new Web3(
          datas &&
          datas.provider &&
          datas.provider != null &&
          datas.provider != undefined &&
          datas.provider != ""
            ? datas.provider
            : window.ethereum
        );
        var bonjourContract = new web3.eth.Contract(
          bonjourapi,
          config.bonjourcontract
        );
        let owneraddress = await bonjourContract.methods.owner().call();
        if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
          if (
            claimaddress &&
            claimaddress != null &&
            claimaddress != undefined &&
            claimaddress != ""
          ) {
            if (web3.utils.isAddress(claimaddress)) {
              let userdetails = await bonjourContract.methods
                .users(claimaddress)
                .call();
              let _status = await bonjourContract.methods
                .claimBlockAddress(claimaddress)
                .call();
              if (userdetails.isExist) {
                if (_status == false) {
                  arr.push(claimaddress);
                  await bonjourContract.methods.addclaimBlockAddress(arr).send({
                    from: datas.address,
                  });
                  let rect = {
                    address: claimaddress,
                  };
                  let _records = await add_Address(rect);
                  if (_records && _records.data && _records.data.message) {
                    setclaimprogress("false");
                    toastAlert("success", _records.data.message, "network");
                    setclaimaddress("");
                    getclaimlist();
                  }
                } else {
                  setclaimprogress("false");
                  toastAlert(
                    "success",
                    "Already Wallet Added to list",
                    "network"
                  );
                }
              } else {
                setclaimprogress("false");
                toastAlert(
                  "success",
                  "User wallet not joined under our Bonjour",
                  "network"
                );
              }
            } else {
              setclaimprogress("false");
              toastAlert("error", "Enter Valid Address", "network");
            }
          } else {
            setclaimprogress("false");
            toastAlert("error", "Enter Valid Address", "network");
          }
        } else {
          setclaimprogress("false");
          toastAlert("error", "Login into Admin Address", "network");
        }
      } else {
        setclaimprogress("false");
        toastAlert("error", "Please select BSC chain network", "network");
      }
    } catch (err) {
      console.log(err, "--");
      toastAlert("error", "Process Cancelled", "network");
      setclaimprogress("false");
    }
  }

  async function removeaddress(addr) {
    try {
      if (removeprogress == "false") {
        setremoveprogress("true");
        let datas = await getCurAddr();
        if (
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        ) {
          let web3 = new Web3(
            datas &&
            datas.provider &&
            datas.provider != null &&
            datas.provider != undefined &&
            datas.provider != ""
              ? datas.provider
              : window.ethereum
          );
          var bonjourContract = new web3.eth.Contract(
            bonjourapi,
            config.bonjourcontract
          );
          let owneraddress = await bonjourContract.methods.owner().call();
          if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
            if (web3.utils.isAddress(addr)) {
              let userdetails = await bonjourContract.methods
                .users(addr)
                .call();
              let _status = await bonjourContract.methods
                .claimBlockAddress(addr)
                .call();
              if (userdetails.isExist) {
                if (_status == true) {
                  await bonjourContract.methods
                    .removeclaimBlockAddress(addr)
                    .send({
                      from: datas.address,
                    });
                  let rect = {
                    address: addr,
                  };
                  let _records = await remove_Address(rect);
                  if (_records && _records.data && _records.data.message) {
                    setremoveprogress("false");
                    toastAlert("success", _records.data.message, "network");
                    getclaimlist();
                  }
                } else {
                  setremoveprogress("false");
                  toastAlert(
                    "success",
                    "Wallet does not exist in list",
                    "network"
                  );
                }
              } else {
                setremoveprogress("false");
                toastAlert(
                  "success",
                  "User wallet not joined under our Bonjour",
                  "network"
                );
              }
            } else {
              setremoveprogress("false");
              toastAlert("error", "Invalid Address", "network");
            }
          } else {
            setremoveprogress("false");
            toastAlert("error", "Login into Admin Address", "network");
          }
        } else {
          setremoveprogress("false");
          toastAlert("error", "Please select BSC chain network", "network");
        }
      } else {
        toastAlert(
          "error",
          "Please Wait Already processing a request",
          "network"
        );
      }
    } catch (err) {
      toastAlert("error", "Process Cancelled", "network");
      setremoveprogress("false");
    }
  }

  async function removeaddressNew(addr) {
    try {
      if (removeprogress == "false") {
        setremoveprogress1("true");
        let datas = await getCurAddr();
        if (
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        ) {
          let web3 = new Web3(
            datas &&
            datas.provider &&
            datas.provider != null &&
            datas.provider != undefined &&
            datas.provider != ""
              ? datas.provider
              : window.ethereum
          );
          var bonjourContract = new web3.eth.Contract(
            bonjourapi,
            config.bonjourcontract
          );
          let owneraddress = await bonjourContract.methods.owner().call();
          if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
            if (web3.utils.isAddress(addr)) {
              let userdetails = await bonjourContract.methods
                .users(addr)
                .call();
              let _status = await bonjourContract.methods
                .allowClaim(addr)
                .call();
              if (userdetails.isExist) {
                if (_status == true) {
                  await bonjourContract.methods
                    .removeAllowClaim(addr)
                    .send({
                      from: datas.address,
                    });
                  let rect = {
                    address: addr,
                  };
                  let _records = await remove_Address(rect);
                  if (_records && _records.data && _records.data.message) {
                    setremoveprogress1("false");
                    toastAlert("success", _records.data.message, "network");
                    getEligiblelist();
                  }
                } else {
                  setremoveprogress1("false");
                  toastAlert(
                    "success",
                    "Wallet does not exist in list",
                    "network"
                  );
                }
              } else {
                setremoveprogress1("false");
                toastAlert(
                  "success",
                  "User wallet not joined under our Bonjour",
                  "network"
                );
              }
            } else {
              setremoveprogress1("false");
              toastAlert("error", "Invalid Address", "network");
            }
          } else {
            setremoveprogress1("false");
            toastAlert("error", "Login into Admin Address", "network");
          }
        } else {
          setremoveprogress1("false");
          toastAlert("error", "Please select BSC chain network", "network");
        }
      } else {
        toastAlert(
          "error",
          "Please Wait Already processing a request",
          "network"
        );
      }
    } catch (err) {
      toastAlert("error", "Process Cancelled", "network");
      setremoveprogress1("false");
    }
  }

  async function distributeglobal() {
    try {
      setprogress("true");
      let datas = await getCurAddr();
      if (
        datas &&
        datas.address &&
        datas.address != undefined &&
        datas.address != null &&
        datas.address != "" &&
        localStorage.getItem("account")
      ) {
        let web3 = new Web3(
          datas &&
          datas.provider &&
          datas.provider != null &&
          datas.provider != undefined &&
          datas.provider != ""
            ? datas.provider
            : window.ethereum
        );
        var bonjourContract = new web3.eth.Contract(
          bonjourapi,
          config.bonjourcontract
        );
        let owneraddress = await bonjourContract.methods.owner().call();
        if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
          if (globalpoolamount && parseFloat(globalpoolamount) > 0) {
            let globamt = parseFloat(globalshare) * 1e18;
            if (globamt && parseFloat(globamt) > 0) {
              if (parseFloat(globamt) <= parseFloat(globalpoolamount)) {
                let amt = await convert(globamt);
                let register = await bonjourContract.methods
                  .globalPoolDistribution(amt.toString())
                  .send({
                    from: datas.address,
                  });
                if (register && register.status && register.transactionHash) {
                  setprogress("false");
                  toastAlert("success", "Distributed Successfully", "network");
                  window.location.reload();
                } else {
                  setprogress("false");
                  toastAlert("success", "Failed , try again later", "network");
                }
              } else {
                setprogress("false");
                let msg =
                  "Amount must be less than or equal to Global Volume " +
                  (parseFloat(globalpoolamount) / 1e18).toFixed(2);
                toastAlert("error", msg, "network");
              }
            } else {
              setprogress("false");
              toastAlert("success", "Enter Valid Amount", "network");
            }
          } else {
            setprogress("false");
            toastAlert("error", "Insufficient Global Pool Amount", "network");
          }
        } else {
          setprogress("false");
          toastAlert("error", "Login into Admin Address", "network");
        }
      } else {
        setprogress("false");
        toastAlert("error", "Please select BSC chain network", "network");
      }
    } catch (err) {
      toastAlert("error", "Process Cancelled", "network");
      setprogress("false");
    }
  }

  async function safewithdraw() {
    try {
      setwithdrawprogress("true");
      if (withamt && parseFloat(withamt) > 0) {
        if (withaddress) {
          let datas = await getCurAddr();
          if (
            datas &&
            datas.address &&
            datas.address != undefined &&
            datas.address != null &&
            datas.address != "" &&
            localStorage.getItem("account")
          ) {
            let web3 = new Web3(
              datas &&
              datas.provider &&
              datas.provider != null &&
              datas.provider != undefined &&
              datas.provider != ""
                ? datas.provider
                : window.ethereum
            );
            if (web3.utils.isAddress(withaddress)) {
              var bonjourContract = new web3.eth.Contract(
                bonjourapi,
                config.bonjourcontract
              );
              let owneraddress = await bonjourContract.methods.owner().call();
              let amt = parseFloat(withamt) * 1e18;
              amt = await convert(amt);
              if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
                let register = await bonjourContract.methods
                  .claim(amt.toString(), withaddress)
                  .send({
                    from: datas.address,
                  });
                if (register && register.status && register.transactionHash) {
                  setwithdrawprogress("false");
                  toastAlert(
                    "success",
                    "Withdraw Successfully Done",
                    "network"
                  );
                  window.location.reload();
                } else {
                  setwithdrawprogress("false");
                  toastAlert("success", "Failed , try again later", "network");
                }
              } else {
                setwithdrawprogress("false");
                toastAlert("error", "Login into Admin Address", "network");
              }
            } else {
              setwithdrawprogress("false");
              toastAlert("error", "Please Enter Valid Address", "network");
            }
          } else {
            setwithdrawprogress("false");
            toastAlert("error", "Please select BSC chain network", "network");
          }
        } else {
          setwithdrawprogress("false");
          toastAlert("error", "Please Enter Valid Address", "network");
        }
      } else {
        setwithdrawprogress("false");
        toastAlert("error", "Please Enter Valid Amount", "network");
      }
    } catch (err) {
      console.log(err, "===df");
      setwithdrawprogress("false");
      toastAlert("error", "Process Cancelled", "network");
    }
  }

  async function autosafewithdraw() {
    try {
      setautowithdrawprogress("true");
      if (autowithamt && parseFloat(autowithamt) > 0) {
        if (autowithaddress) {
          let datas = await getCurAddr();
          if (
            datas &&
            datas.address &&
            datas.address != undefined &&
            datas.address != null &&
            datas.address != "" &&
            localStorage.getItem("account")
          ) {
            let web3 = new Web3(
              datas &&
              datas.provider &&
              datas.provider != null &&
              datas.provider != undefined &&
              datas.provider != ""
                ? datas.provider
                : window.ethereum
            );
            if (web3.utils.isAddress(autowithaddress)) {
              var bonjourautopoolContract = new web3.eth.Contract(
                bonjourautopoolapi,
                config.autopoolcontract
              );
              let owneraddress = await bonjourautopoolContract.methods.owner().call();
              let amt = parseFloat(autowithamt) * 1e18;
              amt = await convert(amt);
              if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
                let register = await bonjourautopoolContract.methods
                  .safeWithdraw(amt.toString(), autowithaddress)
                  .send({
                    from: datas.address,
                  });
                if (register && register.status && register.transactionHash) {
                  setautowithdrawprogress("false");
                  toastAlert(
                    "success",
                    "Withdraw Successfully Done",
                    "network"
                  );
                  window.location.reload();
                } else {
                  setautowithdrawprogress("false");
                  toastAlert("success", "Failed , try again later", "network");
                }
              } else {
                setautowithdrawprogress("false");
                toastAlert("error", "Login into Admin Address", "network");
              }
            } else {
              setautowithdrawprogress("false");
              toastAlert("error", "Please Enter Valid Address", "network");
            }
          } else {
            setautowithdrawprogress("false");
            toastAlert("error", "Please select BSC chain network", "network");
          }
        } else {
          setautowithdrawprogress("false");
          toastAlert("error", "Please Enter Valid Address", "network");
        }
      } else {
        setautowithdrawprogress("false");
        toastAlert("error", "Please Enter Valid Amount", "network");
      }
    } catch (err) {
      console.log(err, "===df");
      setautowithdrawprogress("false");
      toastAlert("error", "Process Cancelled", "network");
    }
  }

  async function earnlimitupdate() {
    try {
      setearnprogress("true");
      if (earnlimit && parseFloat(earnlimit) > 0) {
        let datas = await getCurAddr();
        if (
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        ) {
          let web3 = new Web3(
            datas &&
            datas.provider &&
            datas.provider != null &&
            datas.provider != undefined &&
            datas.provider != ""
              ? datas.provider
              : window.ethereum
          );
          var bonjourContract = new web3.eth.Contract(
            bonjourapi,
            config.bonjourcontract
          );
          let owneraddress = await bonjourContract.methods.owner().call();
          if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
            let register = await bonjourContract.methods
              .updateearnLimit(earnlimit.toString())
              .send({
                from: datas.address,
              });
            if (register && register.status && register.transactionHash) {
              setearnprogress("false");
              toastAlert("success", "Updated Successfully", "network");
              window.location.reload();
            } else {
              setearnprogress("false");
              toastAlert("success", "Failed , try again later", "network");
            }
          } else {
            setearnprogress("false");
            toastAlert("error", "Login into Admin Address", "network");
          }
        } else {
          setearnprogress("false");
          toastAlert("error", "Please select BSC chain network", "network");
        }
      } else {
        setearnprogress("false");
        toastAlert("error", "Please Enter Valid Limit", "network");
      }
    } catch (err) {
      console.log(err, "===df");
      setearnprogress("false");
      toastAlert("error", "Process Cancelled", "network");
    }
  }

  async function tokenpriceupdate() {
    try {
      settokenprogress("true");
      if (tokenprice && parseFloat(tokenprice) > 0) {
        let datas = await getCurAddr();
        if (
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        ) {
          let web3 = new Web3(
            datas &&
            datas.provider &&
            datas.provider != null &&
            datas.provider != undefined &&
            datas.provider != ""
              ? datas.provider
              : window.ethereum
          );
          var bonjourContract = new web3.eth.Contract(
            bonjourapi,
            config.bonjourcontract
          );
          let owneraddress = await bonjourContract.methods.owner().call();
          if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
            let register = await bonjourContract.methods
              .setTokenPrice(tokenprice.toString())
              .send({
                from: datas.address,
              });
            if (register && register.status && register.transactionHash) {
              settokenprogress("false");
              toastAlert("success", "Updated Successfully", "network");
              window.location.reload();
            } else {
              settokenprogress("false");
              toastAlert("success", "Failed , try again later", "network");
            }
          } else {
            settokenprogress("false");
            toastAlert("error", "Login into Admin Address", "network");
          }
        } else {
          settokenprogress("false");
          toastAlert("error", "Please select BSC chain network", "network");
        }
      } else {
        settokenprogress("false");
        toastAlert("error", "Please Enter Valid Value", "network");
      }
    } catch (err) {
      settokenprogress("false");
      toastAlert("error", "Process Cancelled", "network");
    }
  }

  async function updateminwithdraw() {
    try {
      setminprogress("true");
      if (minval && parseFloat(minval) > 0) {
        let datas = await getCurAddr();
        if (
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        ) {
          let web3 = new Web3(
            datas &&
            datas.provider &&
            datas.provider != null &&
            datas.provider != undefined &&
            datas.provider != ""
              ? datas.provider
              : window.ethereum
          );
          var bonjourContract = new web3.eth.Contract(
            bonjourapi,
            config.bonjourcontract
          );
          let owneraddress = await bonjourContract.methods.owner().call();
          if (owneraddress.toLowerCase() == datas.address.toLowerCase()) {
            let register = await bonjourContract.methods
              .setminWithdrawAmount(minval.toString())
              .send({
                from: datas.address,
              });
            if (register && register.status && register.transactionHash) {
              setminprogress("false");
              toastAlert("success", "Updated Successfully", "network");
              window.location.reload();
            } else {
              setminprogress("false");
              toastAlert("success", "Failed , try again later", "network");
            }
          } else {
            setminprogress("false");
            toastAlert("error", "Login into Admin Address", "network");
          }
        } else {
          setminprogress("false");
          toastAlert("error", "Please select BSC chain network", "network");
        }
      } else {
        setminprogress("false");
        toastAlert("error", "Please Enter Valid Value", "network");
      }
    } catch (err) {
      setminprogress("false");
      toastAlert("error", "Process Cancelled", "network");
    }
  }

  async function fetchrecord(start_date, end_date, _event) {
    try {
      let data = {
        startdate: start_date != "" ? start_date : today,
        enddate: end_date != "" ? end_date : nextday,
        event: _event,
      };
      let rec = await filter_event(data);
      if (rec && rec.data && rec.data.data) {
        setfilterrec(rec.data.data);
        let record = [];
        for (let i in rec.data.data) {
          var obj_rec = {
            SNO: parseInt(i) + 1,
            UserId: rec.data.data[i].userid,
            Address: rec.data.data[i].address,
            Activity:
              rec.data.data[i].event == "joined"
                ? "Join"
                : rec.data.data[i].event == "reinvest"
                ? "Re-Invest"
                : rec.data.data[i].event == "retopup"
                ? "Re-Topup"
                : rec.data.data[i].event == "globalclaim"
                ? "Claim"
                : "Claim",
            Amount:
              parseInt(rec.data.data[i].amount).toString().length > 8
                ? (parseFloat(rec.data.data[i].amount) / 1e18).toFixed(2)
                : parseFloat(rec.data.data[i].amount).toFixed(2),
            Date: moment(rec.data.data[i].createdAt).format(
              "MMM Do YYYY, h:mm:ss A"
            ),
          };
          record.push(obj_rec);
          if (parseInt(i) + 1 == rec.data.data.length) {
            settabledata(record);
          }
        }
      } else {
        setfilterrec([]);
      }
    } catch (err) {
      console.log(err, "====s=ss=");
    }
  }

  const onKeyUp = (e) => {
    console.log(e.target.value, "e.target.value");
    var numbers = /^[0-9]+$/;
    if (!e.target.value.match(numbers)) {
      toast.warn("Please enter valid");
      console.log(e.target.value, "e.target.value");
      return false;
    }
  };

  const validPositive = (e) => {
    console.log(
      new RegExp(`^\\d*(\\.\\d{0,8})?$`).test(e.target.value),
      "valllluee"
    );
    if (
      new RegExp(`^\\d*(\\.\\d{0,8})?$`).test(e.target.value) ||
      (e.target.value = "")
    ) {
      e.preventDefault();
    }
  };

  const updatetaxperc = async () => {
    try {
      let datas = await getCurAddr();
      if (
        !(
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        )
      ) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }
      let web3 = new Web3(
        datas &&
        datas.provider &&
        datas.provider != null &&
        datas.provider != undefined &&
        datas.provider != ""
          ? datas.provider
          : window.ethereum
      );

      var currAddr = await web3.eth.getAccounts();
      console.log(currAddr, "web3");
      if (!currAddr) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }

      if (taxperc == "") {
        toast.error("Field must not be empty", toasterOption);
        return false;
      }
      setsubmitButton(true);

      const Contract = new web3.eth.Contract(
        lotteryABI,
        config.ContractAddress
      );
      var result = await Contract.methods
        .updateAdminTaxPercent(taxperc)
        .send({ from: currAddr[0] })
        .then(async (result) => {
          toast.success("Tax updated successfully", toasterOption);

          setTimeout(() => {
            window.location.reload();
          }, 4000);
        });
      setsubmitButton(false);
    } catch (err) {
      console.log(err);
      setsubmitButton(false);
    }
  };

  const toggleDisplay = () => {
    if (activedata == false) {
      setActivedata(true);
    } else {
      setActivedata(false);
    }
  };

  const updateenableAdminTax = async () => {
    try {
      let datas = await getCurAddr();
      if (
        !(
          datas &&
          datas.address &&
          datas.address != undefined &&
          datas.address != null &&
          datas.address != "" &&
          localStorage.getItem("account")
        )
      ) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }
      let web3 = new Web3(
        datas &&
        datas.provider &&
        datas.provider != null &&
        datas.provider != undefined &&
        datas.provider != ""
          ? datas.provider
          : window.ethereum
      );

      var currAddr = await web3.eth.getAccounts();
      console.log(currAddr, "web3");
      if (!currAddr) {
        toast.warning("OOPS!..connect Your Wallet", toasterOption);
        setsubmitButton(false);
        return false;
      }
      setsubmitButton(true);

      console.log(activedata, "activedata");

      const Contract = new web3.eth.Contract(
        lotteryABI,
        config.ContractAddress
      );
      var result = await Contract.methods
        .enableAdminTax(activedata)
        .send({ from: currAddr[0] })
        .then(async (result) => {
          toast.success("Updated successfully", toasterOption);

          setTimeout(() => {
            window.location.reload();
          }, 4000);
        });
      setsubmitButton(false);
    } catch (err) {
      console.log(err);
      setsubmitButton(false);
    }
  };

  return (
    <div>
      <Navbar
        handleDrawerOpen={handleDrawerOpen}
        open={open}
        handleMenu={handleMenu}
        handleClose={handleClose}
        anchorEl={anchorEl}
      />
      <ScrollToTopOnMount />

      <div className="pagecolor">
        <section className="settings">
          <div className="container">
            <h2 className="inner_title mb-4">Update Lottery Settings</h2>
            <div className="dashboard_panel">
              <div className="row">
                <div className="col-lg-6 primary_box dash_box mt-4 dflx-none">
                  <label for="exampleFormControlInput1" class="form-label">
                    OPERATOR
                  </label>
                  <input
                    type="text"
                    class="form-control primary_inp mb-2"
                    id="operator"
                    value={operator}
                    placeholder="Enter Address"
                    onChange={onChange}
                    style={{ color: "white" }}
                  />
                  {validateError.operator && (
                    <span className="text-danger">
                      {validateError.operator}
                    </span>
                  )}
                  <label for="exampleFormControlInput1" class="form-label">
                    TREASURY
                  </label>
                  <input
                    type="text"
                    class="form-control primary_inp mb-2"
                    id="treasury"
                    value={treasury}
                    placeholder="Enter Address"
                    onChange={onChange}
                    style={{ color: "white" }}
                  />
                  {validateError.treasury && (
                    <span className="text-danger">
                      {validateError.treasury}
                    </span>
                  )}
                  <label for="exampleFormControlInput1" class="form-label">
                    INJECTOR
                  </label>
                  <input
                    type="text"
                    class="form-control primary_inp mb-2"
                    id="injector"
                    value={injector}
                    placeholder="Enter Address"
                    onChange={onChange}
                    style={{ color: "white" }}
                  />
                  {validateError.injector && (
                    <span className="text-danger">
                      {validateError.injector}
                    </span>
                  )}
                  <br />
                  <button
                    className="primary_btn"
                    type="button"
                    onClick={handleFormSubmit}
                  >
                    {submitButton && (
                      <i class="fas fa-spinner fa-spin mr-2"></i>
                    )}
                    Add
                  </button>
                  {submitButton && (
                    <lable>Don't refresh when page loading...</lable>
                  )}
                </div>
              </div>
            </div>
            <br />
            <br />
            <h2 className="inner_title mb-4">Update Price</h2>
            <div className="dashboard_panel">
              <div className="row">
                <div className="col-lg-6 primary_box dash_box mt-4 dflx-none">
                  <label for="exampleFormControlInput1" class="form-label">
                    Ticket Price
                  </label>
                  <input
                    type="text"
                    class="form-control primary_inp mb-2"
                    id="ticketprize"
                    value={ticketprize}
                    placeholder="Enter price"
                    onChange={(e) => setticketprize(e.target.value)}
                    style={{ color: "white" }}
                  />
                  <label for="exampleFormControlInput1" class="form-label">
                    Dollar Price
                  </label>
                  <input
                    type="text"
                    class="form-control primary_inp mb-2"
                    id="AEDprize"
                    value={AEDprize}
                    placeholder="Enter price"
                    onChange={(e) => setAEDprize(e.target.value)}
                    style={{ color: "white" }}
                  />

                  <br />
                  <button
                    className="primary_btn"
                    type="button"
                    onClick={handleFormSubmit2}
                  >
                    {submitButton && (
                      <i class="fas fa-spinner fa-spin mr-2"></i>
                    )}
                    Add
                  </button>
                  {submitButton && (
                    <lable>Don't refresh when page loading...</lable>
                  )}
                </div>
              </div>
            </div>
            <br /> <br />
            <br />
            <br />
            <h2 className="inner_title mb-4">Update Tax Percentage</h2>
            <div className="dashboard_panel">
              <div className="row">
                <div className="col-lg-6 primary_box dash_box mt-4 dflx-none">
                  <label for="exampleFormControlInput1" class="form-label">
                    Percentage
                  </label>
                  <input
                    type="text"
                    class="form-control primary_inp mb-2"
                    id="ticketprize"
                    value={taxperc}
                    onInput={validPositive}
                    placeholder="Enter price"
                    onChange={(e) => settaxperc(e.target.value)}
                    style={{ color: "white" }}
                  />
                  <br />
                  <button
                    className="primary_btn"
                    type="button"
                    onClick={updatetaxperc}
                  >
                    {submitButton && (
                      <i class="fas fa-spinner fa-spin mr-2"></i>
                    )}
                    Add
                  </button>
                  {submitButton && (
                    <lable>Don't refresh when page loading...</lable>
                  )}
                </div>
              </div>
            </div>
            <br /> <br />
            <br />
            <br />
            <h2 className="inner_title mb-4">Enable Admin Tax</h2>
            <div className="dashboard_panel">
              <div className="row">
                <div className="col-lg-6 primary_box dash_box mt-4 dflx-none">
                  <label for="exampleFormControlInput1" class="form-label">
                    Enable Admin Tax
                  </label>
                  <br />
                  <br />

                  <BootstrapSwitchButton
                    checked={activedata}
                    onstyle="success"
                    offstyle="danger"
                    onlabel="Enable"
                    offlabel="Disable"
                    width={100}
                    onChange={toggleDisplay}
                  />
                  <br />
                  <br />

                  <button
                    className="primary_btn"
                    type="button"
                    onClick={updateenableAdminTax}
                  >
                    {submitButton && (
                      <i class="fas fa-spinner fa-spin mr-2"></i>
                    )}
                    Add
                  </button>
                  {submitButton && (
                    <lable>Don't refresh when page loading...</lable>
                  )}
                </div>
              </div>
            </div>
            <br /> <br />
            <br />
            <br />
            <div>
              <h2 className="inner_title">Start Lottery</h2>
              <div className="row settings_row">
                <div className="col-md-12">
                  <div className="primary_box dash_box mt-4">
                    <div className="form-group row">
                      <div className="col-lg-12 m-auto text-start">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              End Time
                            </label>
                            {/* <input
                              type="text"
                              class="form-control primary_inp"
                              placeholder="End time in timestamp"
                              onChange={onChange1}
                              id="endTime"
                              value={endTime}
                            /> */}

                            <input
                              type="datetime-local"
                              class="form-control primary_inp"
                              onChange={onchange2}
                              id="endTime"
                              name="time"
                              // value={endTime}
                              style={{ maxWidth: "220px" }}
                            />
                            {validateError.endTime && (
                              <span className="text-danger">
                                {validateError.endTime}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Ticket Price
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              id="ticketPice"
                              // onKeyUp={onKeyUp}
                              placeholder="Ticket Price"
                              value={ticketPice}
                              onChange={onChange1}
                              onInput={validPositive}
                            />
                            {validateError.ticketPice && (
                              <span className="text-danger">
                                {validateError.ticketPice}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              First Prize %
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              id="rew1"
                              // onKeyUp={onKeyUp}
                              onInput={validPositive}
                              placeholder=" First Prize %"
                              value={rew1}
                              onChange={onChange1}
                            />
                            {validateError.rew1 && (
                              <span className="text-danger">
                                {validateError.rew1}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Second Prize %
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              // onKeyUp={onKeyUp}
                              onInput={validPositive}
                              id="rew2"
                              placeholder="Second Prize %"
                              value={rew2}
                              onChange={onChange1}
                            />
                            {validateError.rew2 && (
                              <span className="text-danger">
                                {validateError.rew2}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Third Prize %
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              onInput={validPositive}
                              id="rew3"
                              value={rew3}
                              placeholder="Third Prize %"
                              onChange={onChange1}
                            />
                            {validateError.rew3 && (
                              <span className="text-danger">
                                {validateError.rew3}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Fourth Prize %
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              onInput={validPositive}
                              id="rew4"
                              placeholder="Fourth Prize %"
                              value={rew4}
                              onChange={onChange1}
                            />
                            {validateError.rew4 && (
                              <span className="text-danger">
                                {validateError.rew4}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Fifth Prize %
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              id="rew5"
                              placeholder="Fifth Prize %"
                              onInput={validPositive}
                              value={rew5}
                              onChange={onChange1}
                            />
                            {validateError.rew5 && (
                              <span className="text-danger">
                                {validateError.rew5}
                              </span>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Sixth Prize %
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              id="rew6"
                              onInput={validPositive}
                              placeholder="Sixth Prize %"
                              value={rew6}
                              onChange={onChange1}
                            />
                            {validateError.rew6 && (
                              <span className="text-danger">
                                {validateError.rew6}
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          className="primary_btn"
                          type="button"
                          onClick={handleFormSubmit1}
                        >
                          {submitButton && (
                            <i class="fas fa-spinner fa-spin mr-2"></i>
                          )}
                          Add
                        </button>
                        {submitButton && (
                          <lable>Don't refresh when page loading...</lable>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </section>
      </div>
      <div>
        <Lottarylist></Lottarylist>
      </div>
      <div className="inner_wrapper">
        <div className="container">
          <div className="dashboard_panel join_now_panel">
            <div className="row">
              <div className="col-lg-10 m-auto">
                <div className="title_flex">
                  <h2 className="inner_title">Setting</h2>
                  <div className="row settings_row">
                    <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <h2>Safe Withdraw</h2>
                        <div className="form-group row">
                          <div className="col-lg-12 m-auto text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Withdraw Amount
                            </label>
                            <input
                              type="Number"
                              class="form-control primary_inp"
                              id="exampleFormControlInput1"
                              placeholder="Enter Amount"
                              value={withamt}
                              onChange={withamtchange}
                              min="0"
                            />
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Withdraw Address
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              id="exampleFormControlInput1"
                              placeholder="Enter Address"
                              value={withaddress}
                              onChange={withaddrchange}
                            />
                            <button
                              className="primary_btn"
                              type="button"
                              onClick={
                                withdrawprogress == "false"
                                  ? () => safewithdraw()
                                  : () => empty()
                              }
                            >
                              {withdrawprogress == "false"
                                ? "Withdraw"
                                : "Processing..Please Wait.."}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                     <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <h2>AutoPool Safe Withdraw</h2>
                        <div className="form-group row">
                          <div className="col-lg-12 m-auto text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Withdraw Amount
                            </label>
                            <input
                              type="Number"
                              class="form-control primary_inp"
                              id="exampleFormControlInput1"
                              placeholder="Enter Amount"
                              value={autowithamt}
                              onChange={autowithamtchange}
                              min="0"
                            />
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Withdraw Address
                            </label>
                            <input
                              type="text"
                              class="form-control primary_inp"
                              id="exampleFormControlInput1"
                              placeholder="Enter Address"
                              value={autowithaddress}
                              onChange={autowithaddrchange}
                            />
                            <button
                              className="primary_btn"
                              type="button"
                              onClick={
                                autowithdrawprogress == "false"
                                  ? () => autosafewithdraw()
                                  : () => empty()
                              }
                            >
                              {autowithdrawprogress == "false"
                                ? "Withdraw"
                                : "Processing..Please Wait.."}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                       <h2>Earn Limit</h2>
                        <div className="form-group row">
                          <div className="col-lg-12 m-auto text-start">
                            <label for="exampleFormControlInput1" class="form-label">Earn Limit (%) </label>
                            <input type="Number" class="form-control primary_inp" id="exampleFormControlInput1" placeholder="Enter Earn Limit" value={earnlimit} onChange={earnlimitchange} />
                           <button className="primary_btn" type="button" onClick={earnprogress=="false"?()=>earnlimitupdate():()=>empty()}>{earnprogress=="false"?"Update":"Processing..Please Wait.."}</button>
                          </div>
                        </div>                    
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <h2>Update Minimum Withdraw</h2>
                        <div className="form-group row">
                          <div className="col-lg-6 m-auto text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Minimum Withdraw
                            </label>
                            <input
                              type="Number"
                              class="form-control primary_inp"
                              id="exampleFormControlInput1"
                              placeholder="Enter Minimum Value"
                              value={minval}
                              onChange={minvalchange}
                            />
                            <button
                              className="primary_btn"
                              type="button"
                              onClick={
                                minprogress == "false"
                                  ? () => updateminwithdraw()
                                  : () => empty()
                              }
                            >
                              {minprogress == "false"
                                ? "Update"
                                : "Processing..Please Wait.."}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <h2>Update Bonjour Token Price</h2>
                        <div className="form-group row">
                          <div className="col-lg-6 m-auto text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Bonjour Token Price ($)
                            </label>
                            <input
                              type="Number"
                              class="form-control primary_inp"
                              id="exampleFormControlInput1"
                              placeholder="Enter Minimum Value"
                              value={tokenprice}
                              onChange={tokenvalchange}
                            />
                            <button
                              className="primary_btn"
                              type="button"
                              onClick={
                                tokenprogress == "false"
                                  ? () => tokenpriceupdate()
                                  : () => empty()
                              }
                            >
                              {tokenprogress == "false"
                                ? "Update"
                                : "Processing..Please Wait.."}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                       <h2>Maximum Withdraw</h2>
                        <div className="form-group row">
                          <div className="col-lg-12 m-auto text-start">
                            <label for="exampleFormControlInput1" class="form-label">Maximum Withdraw</label>
                            <input type="Number" class="form-control primary_inp" id="exampleFormControlInput1" placeholder="Enter Maximum Value" />
                           <button className="primary_btn" type="button" onClick={progress=="false"?()=>distributeglobal():()=>empty()}>{progress=="false"?"Update":"Processing..Please Wait.."}</button>
                          </div>
                        </div>                    
                      </div> 
                    </div>*/}
                  </div>
                </div>

               {/* <div className="row settings_row">
                  <div class="col-lg-12">
                    <div className="primary_box dash_box">
                      <div className="">
                        <h2>NFC Card Details
                        </h2>
                        <div className="plan_income_table_div w-100">
                          <div className="table-responsive">
                            <table className="table plan_income_table mt-4 w-100">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Wallet Address</th>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Mobile</th>
                                  <th>Address</th>
                                </tr>
                              </thead>
                              <tbody>
                                {nfcrecords &&
                                  nfcrecords.length > 0 &&
                                  nfcrecords.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>{parseInt(index) + 1}</td>
                                        <td>{item.address}</td>
                                        <td>{item.name}</td>
                                        <td>{item.email}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.contactaddress}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>*/}

                <div className="row settings_row">
                  <div class="col-lg-12">
                    <div className="primary_box dash_box">
                      <div className="">
                        <h2>
                          {"Global Pool Distribution ( Global Volume : " +
                            (parseFloat(globalpoolamount) / 1e18).toFixed(2) +
                            " )"}
                        </h2>
                        <div className="col-lg-6 m-auto text-start">
                          <label
                            for="exampleFormControlInput1"
                            class="form-label"
                          >
                            {"Global Pool Amount"}
                          </label>
                          <input
                            type="text"
                            class="form-control primary_inp"
                            id="exampleFormControlInput1"
                            placeholder="Enter Amount"
                            value={globalshare}
                            onChange={globalsharechange}
                          />
                          <button
                            className="primary_btn"
                            type="button"
                            onClick={
                              progress == "false"
                                ? () => distributeglobal()
                                : () => empty()
                            }
                          >
                            {progress == "false"
                              ? "Distribute"
                              : "Processing..Please Wait.."}
                          </button>
                        </div>
                        <div className="plan_income_table_div w-100">
                          <div className="table-responsive">
                            <table className="table plan_income_table mt-4 w-100">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Address</th>
                                </tr>
                              </thead>
                              <tbody>
                                {records &&
                                  records.length > 0 &&
                                  records.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>{parseInt(index) + 1}</td>
                                        <td>{item}</td>
                                      </tr>
                                    );
                                  })}
                                {records && records.length <= 0 && (
                                  <tr>
                                    <td colSpan={2}>
                                      <p className="text-center mt-2">
                                        No Records Found
                                      </p>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row settings_row">
                  <div class="col-lg-12">
                    <div className="primary_box dash_box">
                      <div className="">
                        <h2>Allow Claim address</h2>
                        <div className="col-lg-6 m-auto text-start">
                          <label
                            for="exampleFormControlInput1"
                            class="form-label"
                          >
                            Wallet Address
                          </label>
                          <input
                            type="text"
                            class="form-control primary_inp"
                            id="exampleFormControlInput1"
                            placeholder="Enter Address"
                            value={claimaddress}
                            onChange={claimaddresschange}
                          />
                          <button
                            className="primary_btn"
                            type="button"
                            onClick={
                              claimprogress == "false"
                                ? () => addaddressNew()
                                : () => empty()
                            }
                          >
                            {claimprogress == "false"
                              ? "Add"
                              : "Processing..Please Wait.."}
                          </button>
                        </div>

                        <div className="plan_income_table_div w-100">
                          <div className="table-responsive">
                            {removeprogress1 == "true" && (
                              <p className="text-center mt-2">
                                Processing ... Please Wait....
                              </p>
                            )}
                            <table className="table plan_income_table mt-4 w-100">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Address</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {eligibleClaims &&
                                  eligibleClaims.length > 0 &&
                                  eligibleClaims.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>{parseInt(index) + 1}</td>
                                        <td>{item.address}</td>
                                        <td>
                                          <button
                                            className="primary_btn"
                                            type="button"
                                            onClick={() =>
                                              removeaddressNew(item.address)
                                            }
                                            disabled={
                                              removeprogress == "true"
                                                ? "true"
                                                : ""
                                            }
                                          >
                                            Remove
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                {eligibleClaims && eligibleClaims.length <= 0 && (
                                  <tr>
                                    <td colSpan={3}>
                                      <p className="text-center mt-2">
                                        No Records Found
                                      </p>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        
                        <div className="plan_income_table_div w-100">
                          <div className="table-responsive">
                            {removeprogress == "true" && (
                              <p className="text-center mt-2">
                                Processing ... Please Wait....
                              </p>
                            )}
                            <table className="table plan_income_table mt-4 w-100">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Address</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {claimlist &&
                                  claimlist.length > 0 &&
                                  claimlist.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>{parseInt(index) + 1}</td>
                                        <td>{item.address}</td>
                                        <td>
                                          <button
                                            className="primary_btn"
                                            type="button"
                                            onClick={() =>
                                              removeaddress(item.address)
                                            }
                                            disabled={
                                              removeprogress == "true"
                                                ? "true"
                                                : ""
                                            }
                                          >
                                            Remove
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                {claimlist && claimlist.length <= 0 && (
                                  <tr>
                                    <td colSpan={3}>
                                      <p className="text-center mt-2">
                                        No Records Found
                                      </p>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row settings_row">
                  <div className="col-lg-12">
                    <div className="primary_box dash_box">
                      <div className="">
                        <h2>Fetch Records</h2>
                        <div className="row">
                          <div className="col-lg-6 text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Start Date
                            </label>
                            <input
                              type="datetime-local"
                              class="form-control primary_inp"
                              id="startdate"
                              onChange={startdatechange}
                              max={
                                enddate && enddate != "" ? enddate : currentdate
                              }
                            />
                          </div>
                          <div className="col-lg-6 text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              End Date
                            </label>
                            <input
                              type="datetime-local"
                              class="form-control primary_inp"
                              id="enddate"
                              onChange={enddatechange}
                              min={startdate}
                              max={currentdate}
                            />
                          </div>
                          {/* <div className="col-lg-6 text-start">
                            <label for="exampleFormControlInput1" class="form-label">{"Global Pool Amount"}</label>
                            <input type="file" class="form-control primary_inp" id="exampleFormControlInput1" />
                          </div>
                          <div className="col-lg-6 text-start">
                            <label for="exampleFormControlInput1" class="form-label">{"Global Pool Amount"}</label>
                            <input type="text" class="form-control primary_inp" id="exampleFormControlInput1" placeholder="Enter Amount" value={globalshare}  onChange={globalsharechange}/>
                          </div> */}
                          <div className="col-lg-6 text-start">
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Events
                            </label>
                            <select
                              class="form-control primary_inp"
                              onChange={selectchange}
                            >
                              <option value="all" selected>
                                All
                              </option>
                              <option value="joined">Joined</option>
                              <option value="reinvest">Re-Invest</option>
                              {/*<option value="retopup" >Re-Topup</option>*/}
                              <option value="claim">Claim</option>
                              <option value="globalclaim">Global Claim</option>
                            </select>
                          </div>
                        </div>
                        <div className="text-end">
                          {/*<button className="primary_btn" type="button" onClick={()=>saveuserAsExcel()}>Download User Details</button>*/}
                          <button
                            className="primary_btn"
                            type="button"
                           // onClick={() => saveAsExcel()}
                          >
                            Download History
                          </button>
                        </div>
                        <div className="plan_income_table_div w-100">                          
                          <div className="table-responsive">
                            <table
                              className="table plan_income_table mt-4 w-100 table_scroll"
                              id="filtertable"
                            >
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>User Id</th>
                                  <th>Address</th>
                                  <th>Activity</th>
                                  <th>Amount</th>
                                  <th>Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filterrec &&
                                  filterrec.length > 0 &&
                                  filterrec.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>{parseInt(index) + 1}</td>
                                        <td>{item.userid}</td>
                                        <td>{item.address}</td>
                                        <td>
                                          {item.event == "joined"
                                            ? "Join"
                                            : item.event == "reinvest"
                                            ? "Re-Invest"
                                            : item.event == "retopup"
                                            ? "Re-Topup"
                                            : item.event == "globalclaim"
                                            ? "Claim"
                                            : "Claim"}
                                        </td>
                                        <td>
                                          {parseInt(item.amount).toString()
                                            .length > 8
                                            ? (
                                                parseFloat(item.amount) / 1e18
                                              ).toFixed(2)
                                            : parseFloat(item.amount).toFixed(
                                                2
                                              )}
                                        </td>
                                        <td>
                                          {moment(item.createdAt).format(
                                            "MMM Do YYYY, h:mm:ss A"
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                {filterrec && filterrec.length <= 0 && (
                                  <tr>
                                    <td colSpan={6}>
                                      <p className="text-center mt-2">
                                        No Records Found
                                      </p>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
